import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';
import { baseColors } from '@ncr-retail/mui-theme';

const baseColor = baseColors();

export const savedTransactionStyles = makeStyles(() => ({
  outerContainerStyle: {
    height: 'fit-content',
  },
  categoryHeadStyle: {
    color: themeColor.subheaderLight,
    paddingBottom: '2vh',
    paddingTop: '2vh',
  },
  datePadding: {
    paddingLeft: '1vw',
  },
  posPadding: {
    paddingLeft: '26vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '19.6vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '26.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '18.5vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '17.9vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '17.4vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '18.2vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '17.3vw',
    },
  },
  txnPadding: {
    paddingLeft: '11.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '13.5vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '13.2vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '12.1vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '12.1vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '11.4vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '12.3vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '12vw',
    },
  },
  amountPadding: {
    paddingLeft: '9.5vw',
    '@media (max-height: 1080px)': {
      paddingLeft: '11vw',
    },
    '@media (max-height: 900px)': {
      paddingLeft: '9.6vw',
    },
    '@media (max-height: 768px)': {
      paddingLeft: '8.7vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      paddingLeft: '9.2vw',
    },
    '@media (width: 1024px) and (height: 768px)': {
      paddingLeft: '7.9vw',
    },
    '@media (max-height: 720px)': {
      paddingLeft: '8.3vw',
    },
    '@media (max-height: 576px)': {
      paddingLeft: '7.9vw',
    },
  },

  innerDetailInformationContainer: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: baseColor.tangaroa,
  },

  savedTransactionListContainer: {
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    minHeight: '6.07vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    cursor: 'pointer',
    justifyContent: 'center',
  },

  selected: {
    backgroundColor: themeColor.selectedPrimary,
  },

  outerDetailContainer: {
    justifyContent: 'flex-start',
  },

  row: {
    justifyContent: 'space-between',
    paddingLeft: '1.1713vw',
  },

  showOverflow: {
    overflow: 'inherit',
  },

  containerAlignment: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
}));
